import * as React from "react";

import { Overlay } from "../../../components";
import "./YTOverlay.css";

interface YTOverlayProps {
  onClose: () => void;
  videoSrc: string;
  width?: string | number;
}

const YTOverlay = ({ width = "75%", videoSrc, onClose }: YTOverlayProps) => (
  <Overlay innerClassName="yt-overlay">
    <div className="yt-overlay__container" onClick={onClose}>
      <div style={{ width }}>
        <div className="yt-overlay__iframe-wrapper" onClick={onClose}>
          <iframe
            className="yt-overlay__iframe"
            src={videoSrc}
            allowFullScreen
            frameBorder={0}
          />
        </div>
      </div>
    </div>
  </Overlay>
);

export default YTOverlay;



// WEBPACK FOOTER //
// ./src/routes/LandingPage/components/YTOverlay.tsx